import { getDomain } from '@/BuildUtils'
import { createSharedComposable } from '@vueuse/core'
import { BrandFieldMap, BrandName, BrandNameMap } from '@core/Constants'

export const useBrand = () => {
  const domain = getDomain(new URL(window.location.href).hostname)
  const brand = domain ? BrandNameMap.get(domain) : BrandName.OPPO

  const getBrandField = () => {
    switch (brand) {
      case BrandName.REALME:
        return BrandFieldMap.get(BrandName.REALME)!
      case BrandName.HEYTAP:
        return BrandFieldMap.get(BrandName.HEYTAP)!
      default:
        return BrandFieldMap.get(BrandName.OPPO)!
    }
  }

  return getBrandField()
}

export const useSharedBrand = createSharedComposable(useBrand)
